module.exports = __webpack_public_path__ + "static/media/leavesnew.93b31f48.svg";